/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useTheme, Grid } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';
import HistoryLeftSection from './HistoryLeftSection';
import HistoryRightSection from './HistoryRightSection';

const HistoryContentDesktop = (): JSX.Element => {
  const theme: ICustomTheme = useTheme();

  return (
    <Grid
      container
      justifyContent="center"
      wrap="nowrap"
      css={{ gap: `min(${theme.spacing(10)}px, 4%)` }}
    >
      <Grid item css={{ width: 320, maxWidth: '100%' }}>
        <HistoryLeftSection />
      </Grid>
      <Grid item css={{ flex: 1, minWidth: 0 }}>
        <HistoryRightSection />
      </Grid>
    </Grid>
  );
};

export default HistoryContentDesktop;
